import { Textarea as MantineTextarea } from '@mantine/core';

export const Textarea = MantineTextarea.extend({
	defaultProps: {
		variant: 'primary',
		autosize: true,
	},
});
